import { render } from "./TourCardGrid.vue?vue&type=template&id=1b173abd"
import script from "./TourCardGrid.vue?vue&type=script&lang=js"
export * from "./TourCardGrid.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1b173abd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b173abd', script)) {
    api.reload('1b173abd', script)
  }
  
  module.hot.accept("./TourCardGrid.vue?vue&type=template&id=1b173abd", () => {
    api.rerender('1b173abd', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/TourCardGrid.vue"

export default script